/**
 * SEGMENTATION HELPERS - Mejoras #1 y #2
 * Funciones para dividir texto en segmentos semánticos
 */

/**
 * Divide el texto en segmentos semánticos inteligentes
 * - Preguntas completas entre ¿ y ?
 * - Grupos de número + contexto (ej: "3 caramelos")
 * - Texto restante
 */
function parseTextIntoSegments(text) {
    const segments = [];
    let currentIndex = 0;

    // Regex para encontrar preguntas (¿...?)
    const questionRegex = /¿[^?]+\?/g;
    const questions = [];
    let match;

    while ((match = questionRegex.exec(text)) !== null) {
        questions.push({
            start: match.index,
            end: match.index + match[0].length,
            text: match[0]
        });
    }

    // Procesar el texto
    questions.forEach(q => {
        // Texto antes de la pregunta
        if (currentIndex < q.start) {
            const beforeText = text.substring(currentIndex, q.start).trim();
            if (beforeText) {
                parseDataSegments(beforeText, segments);
            }
        }

        // La pregunta completa
        segments.push({
            text: q.text,
            type: 'question'
        });

        currentIndex = q.end;
    });

    // Texto después de la última pregunta
    if (currentIndex < text.length) {
        const afterText = text.substring(currentIndex).trim();
        if (afterText) {
            parseDataSegments(afterText, segments);
        }
    }

    // Si no hay segmentos, crear uno con todo el texto
    if (segments.length === 0) {
        segments.push({
            text: text.trim(),
            type: 'text'
        });
    }

    return segments;
}

/**
 * Divide texto en segmentos de número + contexto
 * Detecta patrones como "3 caramelos", "12 globos", "23 de melocotón"
 */
function parseDataSegments(text, segments) {
    // Regex mejorada para capturar frases compuestas
    // \d+ : número
    // [a-záéíóúñü]+ : primera palabra (sustantivo)
    // (?:\s+(?:de|del|con|sin|para|y|o)\s+[a-záéíóúñü]+)? : opcional conector + palabra
    const dataRegex = /\b(\d+)\s+([a-záéíóúñü]+(?:\s+(?:de|del|con|sin|para|y|o)\s+[a-záéíóúñü]+)?)\b/gi;
    let lastIndex = 0;
    let match;

    while ((match = dataRegex.exec(text)) !== null) {
        // Texto antes del número
        if (match.index > lastIndex) {
            const beforeText = text.substring(lastIndex, match.index).trim();
            if (beforeText) {
                segments.push({
                    text: beforeText,
                    type: 'text'
                });
            }
        }

        // Número + contexto completo
        segments.push({
            text: match[0],
            type: 'data'
        });

        lastIndex = match.index + match[0].length;
    }

    // Texto restante
    if (lastIndex < text.length) {
        const remaining = text.substring(lastIndex).trim();
        if (remaining) {
            segments.push({
                text: remaining,
                type: 'text'
            });
        }
    }
}

// Export for use in wizard
if (typeof window !== 'undefined') {
    window.parseTextIntoSegments = parseTextIntoSegments;
    window.parseDataSegments = parseDataSegments;
}
